var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVanBlue = function SvgVanBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73.06,
    height: 32.332,
    viewBox: "0 0 73.06 32.332",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(69.146 15.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M415.915,518.954a3.719,3.719,0,0,0,3.7,3.489h.213v-3.171a3,3,0,0,0-.027-.318Z",
    transform: "translate(-415.915 -518.954)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(65.66 24.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M414.094,527.714a3.945,3.945,0,0,0,3.406,1.967h1.911a1.112,1.112,0,0,0,1.109-1.11v-2.544h-7.4Z",
    transform: "translate(-413.12 -526.026)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M431.086,519.372,423,517.623a8.571,8.571,0,0,1-2.889-1.916l-.014-.012-6.893-7.544a5.783,5.783,0,0,0-4.259-1.878H363c-1.388,0-2.518.59-2.518,1.313v13.633h72.811A3.119,3.119,0,0,0,431.086,519.372Zm-13.841-1.235a1.92,1.92,0,0,1-1.762,1.131H405.158a2.129,2.129,0,0,1-2.127-2.127v-5.537a3.04,3.04,0,0,1,3.036-3.036h3.146a2.794,2.794,0,0,1,2.274,1.171l5.462,6.323A1.92,1.92,0,0,1,417.245,518.137Z",
    transform: "translate(-360.478 -506.273)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(50.444 20.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M407.752,534.6a6.826,6.826,0,0,0,6.026-10.041l-.1-.178c-.093-.163-.191-.324-.3-.478a6.67,6.67,0,0,0-.5-.606,3.1,3.1,0,0,0-2.117-.846H404.4a3.077,3.077,0,0,0-1.262.3,6.821,6.821,0,0,0,4.615,11.853Zm0-10.119a3.288,3.288,0,1,1-3.288,3.288A3.292,3.292,0,0,1,407.752,524.484Z",
    transform: "translate(-400.921 -522.455)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(0 24.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M360.478,527.886a1.8,1.8,0,0,0,1.795,1.795h4.861a4.521,4.521,0,0,0,3.815-2.082l1.013-1.573H360.478Z",
    transform: "translate(-360.478 -526.026)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M433.325,523.312a4.588,4.588,0,0,1-4.57-4.358H360.478v7.951h12.044l.621-.964c.06-.094.133-.177.2-.268a7.518,7.518,0,0,1,1.343-1.451,7.406,7.406,0,0,1,1.675-1.045,7.5,7.5,0,0,1,3.092-.677h2.1a6.935,6.935,0,0,1,3.507,1.115,7.537,7.537,0,0,1,1.69,1.421,5.467,5.467,0,0,1,.674.924l.515.929,1.22,2.2h0a4.543,4.543,0,0,0,3.97,2.339h11.979a3.135,3.135,0,0,0,2.705-1.563l3.129-5.418a4.068,4.068,0,0,1,2.96-1.965,3.917,3.917,0,0,1,.5-.032h6.356a3.964,3.964,0,0,1,1.01.132,4.015,4.015,0,0,1,1.956,1.2,3.905,3.905,0,0,1,.5.665l.228.4.095.165,1.1,1.895h7.9v-3.593Z",
    transform: "translate(-360.478 -503.137)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(13.138 20.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M378.949,522.495h-2.1a6.593,6.593,0,0,0-5.337,2.717,6.83,6.83,0,1,0,13.013,1.136l-.465-.841A6.545,6.545,0,0,0,378.949,522.495Zm-1.108,8.555a3.288,3.288,0,1,1,3.288-3.288A3.292,3.292,0,0,1,377.841,531.05Z",
    transform: "translate(-371.011 -522.495)",
    fill: "#06016c"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVanBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vanBlue.c20d870d.svg";
export { ForwardRef as ReactComponent };